import React from 'react';
import { parseContent } from '@/components/(blog)/post/util/parseContent';

interface MainContentProps {
    processedContent: string;
    className?: string;
    title?: string;
}

const MainContent: React.FC<MainContentProps> = ({
    processedContent,
    className = '',
    title = '',
}) => {
    return (
        <div
            className={`post-content prose dark:prose-invert max-w-full w-full min-w-0 mx-auto lg:px-4 mb-5 break-words leading-[2.1] text-justify 
    text-gray-600 dark:text-gray-300 
    [&_:is(p,div,li)]:!text-gray-600 dark:[&_:is(p,div,li)]:!text-gray-300
    prose-headings:text-start prose-headings:font-bold prose-headings:!text-black dark:prose-headings:!text-white
    prose-h2:text-2xl 
    prose-h3:opacity-85 prose-h3:text-[20px] 
    prose-h4:opacity-80 prose-h4:text-[18px] 
    prose-h5:opacity-75 prose-h5:text-base 
    prose-h6:opacity-75 prose-h6:text-sm 
    prose-li:text-start prose-ul:pr-5 
    [&_[class*="tableContainer"]]:!max-w-full [&_[class*="tableContainer"]]:!w-full
    [&_[class*="tableWrapper"]]:!max-w-full [&_[class*="tableWrapper"]]:!w-full [&_[class*="tableWrapper"]]:!block
    [&_figure]:!max-w-full
    ${className}`}
        >
            {parseContent(processedContent, title)}
        </div>
    );
};

export default MainContent;
